module.exports = __webpack_public_path__ + "img/elementwidths_jaka.01795f3c.png";